import {
  kldivergence
} from 'mathjs'

const calculateKLDivergence = (array1, array2) => {

  /* 
    This function returns the KL Divergence for two 1-dim arrays of numbers.
  */

  // https://mathjs.org/docs/reference/functions/kldivergence.html
  let result = kldivergence(array1, array2)
  
  return result;
}

export default calculateKLDivergence;